import { getUuidV4 } from '@vcd-ecm-ui/Common';

class ActionDivider {
  key: string;

  constructor() {
    this.key = getUuidV4();
  }
}

export default ActionDivider;
